import { execAdmin } from '@src/apis/reware/utils';

import type { QueueStatusResponse, FetchQueueStatusExecResponse } from './types';

export const fetchQueueStatus = async (): Promise<QueueStatusResponse[]> => {
  const query = `
    query getShopifySyncQueueStatus {
      shopifySyncQueueStatus {
        name
        messagesPending
        messagesProcessing
        throughputPerMinute
        estimatedMinutesToClear
        error
      }
    }
  `;

  const data = await execAdmin<Record<string, never>, FetchQueueStatusExecResponse>(
    query,
    { variables: {} },
  );

  const queues = data.shopifySyncQueueStatus;
  // A null list is a failed query, not an empty one. Returning [] here would
  // render as a calm, zeroed dashboard.
  if (queues == null) {
    throw new Error('Queue status is unavailable: the API returned no queue list.');
  }

  const present = queues.filter((queue): queue is QueueStatusResponse => queue != null);
  if (present.length < queues.length) {
    // A null element means the API could not serialize that queue (e.g. a
    // non-null Int came back as NaN). Dropping it silently would read as a
    // queue that no longer exists.
    // eslint-disable-next-line no-console
    console.warn(
      `[shopify-sync] dropped ${queues.length - present.length} unreadable queue(s) from the status response`
    );
  }

  return present;
};
